// extracted by mini-css-extract-plugin
export default {"topNews":"index_topNews_-d4iq","first_title":"index_first_title_-cRf9","second_title":"index_second_title_m8vr-","children":"index_children_pw614"};